import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';
import { ComboMatriculaSecretariaComponent } from './combo-matricula-secretaria.component';

@NgModule({
  declarations: [ComboMatriculaSecretariaComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    ComboPesquisavelModule
  ],
  exports: [ComboMatriculaSecretariaComponent]
})
export class ComboMatriculaSecretariaModule {
}
